import { AuthContextProvider } from 'modules/auth/auth.context';
import * as ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';

// import { ISession, LOCAL_STORAGE_KEY } from 'shared/consts/auth.const';
import { GlobalStyles } from 'twin.macro';
import { App } from './app';
import './font-style.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15000,
    },
  },
});

export function bootstrap() {
  ReactDOM.render(
    <QueryClientProvider client={queryClient}>
      <GlobalStyles />
      <BrowserRouter>
        <AuthContextProvider>
          <App />
        </AuthContextProvider>
      </BrowserRouter>
    </QueryClientProvider>,
    document.getElementById('app')
  );
}
